import { ApolloError } from "apollo-client";
import React, { ComponentClass, PureComponent, ReactNode } from "react";
import { Query } from "react-apollo";

import { IUser } from "../../types/user";
import GetMe from "../repository/withMe/graphql/GetMe";

export interface IWithAuthenticated {
  isAuthenticated: boolean;
}

export default <P extends object>(
  Component: React.ComponentType<P>
): ComponentClass<P> =>
  class WithAuthenticated extends PureComponent<P> {
    public render(): ReactNode {
      return (
        <Query query={GetMe} fetchPolicy="cache-first">
          {({
            data,
            loading,
          }: {
            data: { me: IUser } | undefined;
            error?: ApolloError;
            loading: boolean;
          }): JSX.Element => (
            <Component
              {...this.props}
              isAuthenticated={loading || (data && data.me && data.me.id)}
            />
          )}
        </Query>
      );
    }
  };
